import { CONTACT_TYPE_ID, INVOICE_TYPE_ID, denormalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { gate } from 'hub-http/gates';
import { getEditDefaultActionsData, getPreviewDefaultActionsData, getPrimaryDefaultActionsData, getRemoveDefaultActionsData } from '../default/getDefaultChickletHoverActions';
import { useFetchCrmAssociationSettings } from '../../hooks/useFetchCrmAssociationSettings';
import { jsx as _jsx } from "react/jsx-runtime";
const useActions = args => {
  var _crmAssociationSettin;
  const {
    fromObjectTypeId,
    toObjectTypeId,
    associationDefinition,
    isUngated
  } = args;
  const {
    data: crmAssociationSettings
  } = useFetchCrmAssociationSettings(denormalizeTypeId(toObjectTypeId));
  const unlabeledAssociationType = associationDefinition;
  const isUngatedToFeature = crmAssociationSettings === null || crmAssociationSettings === void 0 || (_crmAssociationSettin = crmAssociationSettings.metadata) === null || _crmAssociationSettin === void 0 || (_crmAssociationSettin = _crmAssociationSettin.gates) === null || _crmAssociationSettin === void 0 ? void 0 : _crmAssociationSettin.value.every(
  // eslint-disable-next-line hubspot-dev/no-bare-gate-strings
  g => isUngated(g) || isUngated(gate(g)));
  const hasCrmAssociationSettingsFas = Boolean(crmAssociationSettings);
  const enabledForCustomLabels = (crmAssociationSettings === null || crmAssociationSettings === void 0 ? void 0 : crmAssociationSettings.metadata.enabledForCustomLabels.value) && isUngatedToFeature;
  const canEditAssociationLabels = hasCrmAssociationSettingsFas ? Boolean(unlabeledAssociationType && enabledForCustomLabels) : Boolean(unlabeledAssociationType);
  return {
    PrimaryAction: getPreviewDefaultActionsData(args),
    SecondaryActions: [getPrimaryDefaultActionsData(args), getRemoveDefaultActionsData(args, {
      disabled: fromObjectTypeId === CONTACT_TYPE_ID || fromObjectTypeId === INVOICE_TYPE_ID,
      disabledMessage: fromObjectTypeId === CONTACT_TYPE_ID ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.disabledContactToSubscriptionTooltip"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.disabledInvoiceToSubscriptionTooltip"
      })
    }), canEditAssociationLabels ? getEditDefaultActionsData(args) : undefined]
  };
};
export default useActions;